import { useState, useEffect } from "react";
import { Helmet } from "react-helmet";

import '../pages/Environment.css'
import EnvironBan from '../components/EnvironBan'
import RADLOGO from "../images/RADLOGO.jpeg";
import ENVIRONMENTOMAGE from "../images/ENVIRONMENTOMAGE.png";
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import {




  FaCity
} from "react-icons/fa";
import {

  FaFileAlt,

} from "react-icons/fa";


import {

  FaTint,

  FaWind,
  FaBolt,
  FaTree,

} from "react-icons/fa";


import {
  FaLeaf,
  FaUniversity,
  FaIndustry,
  FaHospital,
  FaBuilding,
  FaBalanceScale,
  FaRecycle,
  FaClipboardCheck
} from "react-icons/fa";

export default function Enivronment() {


  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);


  return (
    <>
      <Helmet>
        <title>Environmental Audit Services in Madurai | Statutory & Legal Compliance</title>
        <meta name="description" content="Professional Environmental Audit services in Madurai. RAD EnviroNex assesses waste management, emissions, and regulatory compliance for industries and hospitals." />
        <meta name="keywords" content="Environmental Audit Madurai, Environmental Compliance Tamil Nadu, TNPCB Audit, Industrial Environmental Audit, statutory compliance audit, waste management audit" />
        <link rel="canonical" href="https://radenvironex.com/Environment" />
      </Helmet>
      <Navbar />

      <EnvironBan />




      {/* ENVIRONMENTAL AUDIT SECTION */}
      <section id="environmental-audit-section">
        <div className="env-audit-wrapper" data-aos="slide-up">

          <h2 style={{ color: '#0bbcd6', textAlign: 'center' }}>Environmental Audit</h2>

          <p className="env-audit-intro">
            At <strong>RAD EnviroNex,</strong> we provide professional Environmental Audits to assess an organization’s environmental performance and regulatory compliance. Our audit reviews key aspects such as waste management, water usage, emissions, and environmental policies.
            <br />
            The process helps identify potential environmental risks and improvement areas, enabling organizations to adopt responsible practices, meet compliance requirements, and strengthen their commitment to environmental sustainability.
            <br />
            Our Environmental Audit evaluates environmental performance, legal compliance, and best practices related to resource utilization, pollution control, and environmental management systems.
          </p>



          {/* APPLICABLE FOR */}
          <div className="env-audit-grid">

            <div data-aos="slide-up">
              <FaUniversity />
              <span>Educational Institutions</span>
            </div>

            <div data-aos="slide-up" data-aos-delay="100">
              <FaIndustry />
              <span>Industries & Manufacturing Units</span>
            </div>

            <div data-aos="slide-up" data-aos-delay="200">
              <FaHospital />
              <span>Hospitals & Healthcare Facilities</span>
            </div>

            <div data-aos="slide-up" data-aos-delay="300">
              <FaBuilding />
              <span>Commercial Establishments</span>
            </div>

            <div data-aos="slide-up" data-aos-delay="400">
              <FaBalanceScale />
              <span>Environmental Legal Compliance</span>
            </div>

            <div data-aos="slide-up" data-aos-delay="500">
              <FaRecycle />
              <span>Resource Utilization & Pollution Control</span>
            </div>

            <div data-aos="slide-up" data-aos-delay="600">
              <FaClipboardCheck />
              <span>Environmental Management Systems & Best Practices</span>
            </div>

          </div>

        </div>
      </section>




      {/* ENVIRONMENTAL AUDIT – NAAC RELEVANCE */}
      {/* <section id="env-audit-naac-relevance-section">
  <div className="env-naac-wrapper" data-aos="slide-up">

    <h2>NAAC Relevance</h2>

    <p className="env-naac-intro">
      The <strong>Environmental Audit</strong> conducted by
      <strong> RAD EnviroNex</strong> directly supports NAAC quality indicators
      under <strong>Criterion 7 – Institutional Values and Best Practices</strong>.
    </p>

    <div className="env-naac-grid">

      <div data-aos="slide-up">
        <FaLeaf />
        <span>NAAC Criterion 7 – Institutional Values and Best Practices</span>
      </div>

      <div data-aos="slide-up" data-aos-delay="100">
        <FaClipboardCheck />
        <span>Criterion 7.1.6 – Quality Audits on Environment</span>
      </div>

      <div data-aos="slide-up" data-aos-delay="200">
        <FaFileAlt />
        <span>Documentation Support for SSR & DVV Verification</span>
      </div>

    </div>

  </div>
</section> */}

      {/* APPLICABLE FOR SECTION */}
      {/* <section id="audit-applicable-section">
        <div className="audit-applicable-wrapper" data-aos="slide-up">

          <h2>Applicable For</h2>

          <div className="audit-applicable-grid">

            <div data-aos="slide-up">
              <FaUniversity />
              <span>Educational Institutions (NAAC)</span>
            </div>

            <div data-aos="slide-up" data-aos-delay="100">
              <FaHospital />
              <span>Hospitals & Healthcare Facilities</span>
            </div>

            <div data-aos="slide-up" data-aos-delay="200">
              <FaIndustry />
              <span>Industries & Manufacturing Units</span>
            </div>

            <div data-aos="slide-up" data-aos-delay="300">
              <FaBuilding />
              <span>Commercial Buildings & Offices</span>
            </div>

            <div data-aos="slide-up" data-aos-delay="400">
              <FaCity />
              <span>Residential & Mixed-Use Campuses</span>
            </div>

          </div>

        </div>
      </section> */}





      {/* ENVIRONMENTAL AUDIT CERTIFICATE COVERAGE */}
      {/* <section id="env-audit-certificate-section">
  <div className="env-cert-wrapper" data-aos="slide-up">

   
    <div className="env-cert-logo" data-aos="zoom-in">
      <img src={RADLOGO} alt="RAD EnviroNex Logo" />
    </div>

    <h2>What RAD EnviroNex Environmental Audit Certificate Covers</h2>

    <div className="env-cert-grid">

      <div data-aos="slide-up">
        <FaLeaf />
        <span>Environmental Policy & Statutory Compliance</span>
      </div>

      <div data-aos="slide-up" data-aos-delay="100">
        <FaTint />
        <span>Water Consumption, Conservation & Reuse</span>
      </div>

      <div data-aos="slide-up" data-aos-delay="200">
        <FaRecycle />
        <span>Solid, Liquid & Hazardous Waste Management</span>
      </div>

      <div data-aos="slide-up" data-aos-delay="300">
        <FaWind />
        <span>Air, Noise & Environmental Quality Assessment</span>
      </div>

      <div data-aos="slide-up" data-aos-delay="400">
        <FaBolt />
        <span>Energy Usage & Conservation Practices</span>
      </div>

      <div data-aos="slide-up" data-aos-delay="500">
        <FaTree />
        <span>Green Campus Initiatives & Biodiversity</span>
      </div>

      <div data-aos="slide-up" data-aos-delay="600">
        <FaClipboardCheck />
        <span>Environmental Management Practices & Controls</span>
      </div>

    </div>

  </div>
</section>
 */}





      {/* ENERGY AUDIT IMAGE SHOWCASE */}
      {/* <section id="energy-audit-image-section">
        <div
          className="energy-audit-image-wrapper"
          data-aos="slide-up"
        >
          <center>
            <h2>Environmental Audit Assessment & Certification</h2>
          </center>
          <div className="energy-audit-image-box">
            <img
              src={ENVIRONMENTOMAGE}
              alt="RAD EnviroNex Energy Audit Assessment"
            />
          </div>
        </div>
      </section> */}



      <Footer />







    </>
  )
}
